import type {DefaultOptions} from '../../types';
import type {PasswordValueEditorLocalizations, PasswordValueEditorOptions} from './types';

/**
 * @ngdoc constant
 * @name PASSWORD_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.value-editors.password
 *
 * @description
 * For description see {@link PasswordValueEditorOptions}
 *
 * ```javascript
 * {
 *      withConfirmation: false
 * }
 * ```
 */
export const PASSWORD_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<PasswordValueEditorOptions> = {
    withConfirmation: false
};

/**
 * @ngdoc constant
 * @name PASSWORD_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.password
 *
 * @description
 * ```
 * {
 *      description: '',
 *      confirmPassword: 'Confirm password',
 *      noChangeIfEmpty: 'If You don\'t want to change password, leave blank.'
 * }
 * ```
 */
export const PASSWORD_VALUE_EDITOR_DEFAULT_LOCALIZATIONS: Readonly<Required<PasswordValueEditorLocalizations>> = Object.freeze({
    description: '',
    confirmPassword: 'Confirm password',
    noChangeIfEmpty: 'If You don\'t want to change password, leave blank.'
});